import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const ConsultaContribuinteModal = ({
  show,
  title,
  body,
  children,
  primaryLabel,
  loadingConfirmationAction,
  closeHandler,
  size,
  primaryLabelVisible = true,
}) => (
  <Modal scrollable show={show} size={size} onHide={() => closeHandler()} backdrop="static" keyboard={false}>
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>{title}</b>
      </div>
      <div className="card-body">
        <Modal.Body>
          {typeof body === "string" ? <p>{body}</p> : body}
          {children}
        </Modal.Body>

        <Modal.Footer>
          {loadingConfirmationAction ? (
            <Spinner animation="border" role="status" />
          ) : (
            primaryLabelVisible && (
              <Button
                variant="primary"
                onClick={() => {
                  closeHandler();
                }}
              >
                {primaryLabel || "Fechar"}
              </Button>
            )
          )}
        </Modal.Footer>
      </div>
    </div>
  </Modal>
);

export default ConsultaContribuinteModal;
